import { render, staticRenderFns } from "./CondominiumList.vue?vue&type=template&id=b5b6dd82&scoped=true&lang=pug&"
import script from "./CondominiumList.vue?vue&type=script&lang=ts&"
export * from "./CondominiumList.vue?vue&type=script&lang=ts&"
import style0 from "./CondominiumList.vue?vue&type=style&index=0&id=b5b6dd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b6dd82",
  null
  
)

export default component.exports